var _rect, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditDebitCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#ECF1F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3928_42208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4969 11.4083V17.6347H15.9313C15.3662 17.6347 14.9038 18.0919 14.9038 18.6621V21.4568H9.41207C8.84697 21.4568 8.38461 20.9996 8.38461 20.4294V11.4083C8.38461 10.8381 8.84697 10.3809 9.41207 10.3809H24.4745C25.0396 10.3809 25.4969 10.8381 25.4969 11.4083Z",
    fill: "#FF7A7A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4969 12.2622H8.38461V14.4404H25.4969V12.2622Z",
    fill: "#79CAA1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3928_42208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0162 18.6578V27.6737C32.0162 28.2388 31.559 28.7012 30.9888 28.7012H15.9314C15.3663 28.7012 14.904 28.244 14.904 27.6737V18.6578C14.904 18.0927 15.3663 17.6304 15.9314 17.6304H30.9888C31.559 17.6304 32.0162 18.0876 32.0162 18.6578Z",
    fill: "#3876BB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4779 19.5376H16.8099V23.2056H20.4779V19.5376Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.195 10.7655C11.4107 10.7655 11.5803 10.5959 11.5803 10.3802C11.5803 10.1695 11.4107 10 11.195 10C10.9843 10 10.8097 10.1695 10.8097 10.3802C10.8097 10.5959 10.9843 10.7655 11.195 10.7655Z",
    fill: "#1E247E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.989 17.2436H25.8825V11.4076C25.8825 10.6319 25.2506 10 24.4749 10H12.2225C12.0119 10 11.8372 10.1695 11.8372 10.3802C11.8372 10.5959 12.0119 10.7655 12.2225 10.7655H24.4749C24.8294 10.7655 25.1119 11.048 25.1119 11.4076V11.8751H8.77027V11.4076C8.77027 11.0531 9.05796 10.7655 9.41243 10.7655H10.1676C10.3834 10.7655 10.5529 10.5959 10.5529 10.3802C10.5529 10.1695 10.3834 10 10.1676 10H9.41243C8.63156 10 7.99968 10.6319 7.99968 11.4076V20.4235C7.99968 21.2044 8.63156 21.8363 9.41243 21.8363H14.5189V27.6722C14.5189 28.4479 15.1508 29.085 15.9316 29.085H30.989C31.7647 29.085 32.4017 28.4531 32.4017 27.6722V18.6563C32.4017 17.8754 31.7698 17.2436 30.989 17.2436ZM8.77027 12.6457H25.1119V14.0533H8.77027V12.6457ZM9.41243 21.0657C9.05796 21.0657 8.77027 20.778 8.77027 20.4235V14.8239H25.1119V17.2436H15.9316C15.1559 17.2436 14.5189 17.8754 14.5189 18.6563V21.0657H9.41243ZM31.6311 27.6722C31.6311 28.0267 31.3434 28.3144 30.989 28.3144H15.9316C15.5772 28.3144 15.2895 28.0267 15.2895 27.6722V18.6563C15.2895 18.3018 15.5772 18.0141 15.9316 18.0141H30.989C31.3434 18.0141 31.6311 18.3018 31.6311 18.6563V27.6722Z",
    fill: "#1E247E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8103 23.5856H20.4783C20.6889 23.5856 20.8636 23.4109 20.8636 23.2003V19.5323C20.8636 19.3216 20.6889 19.147 20.4783 19.147H16.8103C16.5996 19.147 16.425 19.3216 16.425 19.5323V23.2003C16.425 23.4109 16.5996 23.5856 16.8103 23.5856ZM17.1956 19.9176H20.093V22.815H17.1956V19.9176Z",
    fill: "#1E247E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6645 26.3315H16.3887C16.1781 26.3315 16.0034 26.5062 16.0034 26.7168C16.0034 26.9275 16.1781 27.1021 16.3887 27.1021H18.6645C18.8752 27.1021 19.0498 26.9275 19.0498 26.7168C19.0498 26.5062 18.8803 26.3315 18.6645 26.3315Z",
    fill: "#1E247E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6204 26.3315H20.3446C20.134 26.3315 19.9593 26.5062 19.9593 26.7168C19.9593 26.9275 20.134 27.1021 20.3446 27.1021H22.6204C22.8311 27.1021 23.0057 26.9275 23.0057 26.7168C23.0057 26.5062 22.8311 26.3315 22.6204 26.3315Z",
    fill: "#1E247E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5763 26.3315H24.3005C24.0899 26.3315 23.9152 26.5062 23.9152 26.7168C23.9152 26.9275 24.0899 27.1021 24.3005 27.1021H26.5763C26.7869 27.1021 26.9616 26.9275 26.9616 26.7168C26.9616 26.5062 26.7869 26.3315 26.5763 26.3315Z",
    fill: "#1E247E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5322 26.3315H28.2564C28.0458 26.3315 27.8711 26.5062 27.8711 26.7168C27.8711 26.9275 28.0458 27.1021 28.2564 27.1021H30.5322C30.7428 27.1021 30.9175 26.9275 30.9175 26.7168C30.9175 26.5062 30.7428 26.3315 30.5322 26.3315Z",
    fill: "#1E247E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3928_42208",
    x: 8.38461,
    y: 10.3809,
    width: 17.1123,
    height: 13.0762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308802 0 0 0 0 0.504167 0 0 0 0 0.410392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3928_42208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3928_42208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3928_42208",
    x: 14.904,
    y: 17.6304,
    width: 19.1123,
    height: 13.0708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.38125 0 0 0 0 0.396 0 0 0 0 0.75 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3928_42208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3928_42208",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditDebitCardIcon);
export default __webpack_public_path__ + "static/media/CreditDebitCardIcon.9d360ede72c8277fe95a4d2c12f44600.svg";
export { ForwardRef as ReactComponent };